import React, { useState } from 'react';
import '../styles.css';
import './AddNewProduct.css';
import { SERVER_URL } from '../config';

export default function AddNewProductScreen({ addProductToWishlist }) {
    const [url, setUrl] = useState('');
    const [alertMessage, setAlertMessage] = useState(null); // For showing alerts
    const [loader, setLoader] = useState(false); // For showing a loader

    const handleAddProduct = async () => {
      if (!url) {
        setAlertMessage('Error: Please enter a URL');
        return;
      }
  
      setLoader(true);
      let token = JSON.parse(localStorage.getItem('token'))
      try {
        const response = await fetch(`${SERVER_URL}/add-product`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ url,token }),
        });
  
        const result = await response.json();
        setLoader(false);
        if (result.ok) {
          addProductToWishlist(result.product);
          setAlertMessage('Success: Product added to wishlist');
          setUrl('');
        } else {
          setAlertMessage(result.error || 'Failed to add product. Try adding it by hand.');
        }
      } catch (error) {
        setLoader(false);
        setAlertMessage('Error: An error occurred while adding the product');
        console.error('Error:', error);
      }
    };
  
    return (
      <div className="add-product-container">
        {loader && <div className="loader"><div className='loaderAnimation'></div></div>}
        {alertMessage && <div className="alert">{alertMessage}</div>}
        <input
          type="text"
          className="add-product-input"
          placeholder="Paste product URL here"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button className="add-product-button" onClick={handleAddProduct}>
          Add Product
        </button>
      </div>
    );
  }
